import React from 'react';
import ErrorFallback from '../../../../components/toolbox/ErrorFallback';

/**
 * Error Boundary for the Lecture Registration form
 * Catches rendering errors and provides fallback UI
 * Errors are automatically captured by Sentry
 */
class LectureErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error('Lecture Registration Error Boundary caught an error:', error, errorInfo);

    // Store error details in state
    this.setState({
      error,
      errorInfo
    });

    // Error will be automatically captured by Sentry if configured
    // No need to manually call Sentry.captureException
  }

  handleReset = () => {
    // Reset error state and allow retry
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });

    // Call parent's onClose if provided
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorFallback
          error={this.state.error}
          onBack={this.handleReset}
        />
      );
    }

    // No error, render children normally
    return this.props.children;
  }
}

export default LectureErrorBoundary;
